import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ReactComponent as OnBoarding } from '../../assets/images/onboarding.svg';
import FooterTrustChat from '../../components/common/FooterTrustChat';
import ButtonMain from '../../components/common/ButtonMain';
import { onBoardingApi } from '../../store/features/onBoarding';
import { resetUser } from '../../store/features/loginUser';
import SuccessPopup from '../../components/common/SuccessPopup';
import FailurePopup from '../../components/common/FailurePopup';
import { logoutAll } from '../../store/features/LogoutAll';
import './style.css';

function ProcessComplete(props) {
  const currentLanguage = useSelector(
    (state) => state.language.currentLanguage,
  );
  const t = useSelector(
    (state) => state.language.translations[currentLanguage],
  );
  const [loading, isLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showFailurePopup, setShowFailurePopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [showOkayButton, setShowOkayButton] = useState(true);
  const [showCancelButton, setShowCancelButton] = useState(false);
  const [titleOfPopup, setTitleOfPopup] = useState('');
  const [cancelButtonText, setCancelButtonText] = useState('');

  const onCloseSuccessPopup = () => {
    setShowSuccessPopup(false);
    setAlertMessage('');
    setShowOkayButton(true);
    setShowCancelButton(false);
  };
  const onCloseFailurePopup = () => {
    setShowFailurePopup(false);
    setAlertMessage('');
    setShowOkayButton(true);
    setShowCancelButton(false);
  };

  const {
    boardingPhone,
    boardingName,
    boardingTimezone,
    boardingLanguage,
    customerCompanyWebsite,
    customerAssignRole,
    leadContainer,
    leadJobTilte,
    emailBoarding,
    logoUpload,
    setSelectOnBoarding,
  } = props;

  const buildFormData = () => {
    const formData = new FormData();
    const focusValue = Array.isArray(leadContainer)
      ? leadContainer.join(',')
      : (leadContainer || '');

    formData.append('business_name', boardingName || '');
    formData.append('business_email', emailBoarding || '');
    formData.append('business_phone', boardingPhone || '');
    formData.append('business_staff_count', customerAssignRole || '');
    formData.append('business_website_link', customerCompanyWebsite || '');
    formData.append('business_focus', focusValue);
    formData.append('business_survey', leadJobTilte || '');
    formData.append('business_address', 'Lahore,pakistan');
    formData.append('default_timezone', boardingTimezone || 'UTC');
    formData.append('default_language', boardingLanguage || 'en');

    if (logoUpload instanceof File) {
      formData.append('business_logo', logoUpload);
    }

    return formData;
  };

  const handlerChange = async () => {
    isLoading(true);
    const formData = buildFormData();
    const loginUserDispatcher = dispatch(
      onBoardingApi({
        requestHeaders: formData,
      }),
    );
    loginUserDispatcher
      .then(async (response) => {
        isLoading(false);
        if (response.payload.status === 200) {
          const settingMessage = Promise.resolve(
            setAlertMessage('Congrats, You have been onboarded successfully.'),
          );
          settingMessage.then(() => {
            setShowSuccessPopup(true);
            setCancelButtonText('Go To Login');
            setTitleOfPopup('Successfully Onboarded');
            setShowOkayButton(false);
            setShowCancelButton(true);
          });
          await dispatch(logoutAll());
          localStorage.removeItem('auth_token');
          dispatch(resetUser());
        } else if (response.payload.status === 400) {
          const settingMessage = Promise.resolve(
            setAlertMessage('Oops , User Already Onboarded'),
          );
          settingMessage.then(() => {
            setShowFailurePopup(true);
            setCancelButtonText('Go To Login');
            setTitleOfPopup('Already Onboarded');
            setShowOkayButton(false);
            setShowCancelButton(true);
          });
        } else if (response.payload.status === 403) {
          const settingMessage = Promise.resolve(
            setAlertMessage('Oops , User Already Onboarded'),
          );
          settingMessage.then(() => {
            setShowFailurePopup(true);
            setCancelButtonText('Go To Login');
            setTitleOfPopup('Already Onboarded');
            setShowOkayButton(false);
            setShowCancelButton(true);
          });
        } else if (response.payload.status === 500) {
          const settingMessage = Promise.resolve(
            setAlertMessage(response.payload.message),
          );
          settingMessage.then(() => {
            setShowFailurePopup(true);
            setTitleOfPopup('Error Occured');
            setShowOkayButton(true);
          });
        }
      })
      .catch((error) => {
        isLoading(false);
        const settingMessage = Promise.resolve(setAlertMessage(error.message));
        settingMessage.then(() => {
          setShowFailurePopup(true);
        });
      });
  };
  const cancelButtonAction = async () => {
    dispatch(resetUser());
    navigate('/login', { replace: true });
  };

  return (
    <div className="ProcessComplete-PopUp-Container">
      <SuccessPopup
        show={showSuccessPopup}
        description={alertMessage}
        showOkayButton={showOkayButton}
        showCancelButton={showCancelButton}
        onCancel={cancelButtonAction}
        onOkay={onCloseSuccessPopup}
        displayText={titleOfPopup}
        cancelText={cancelButtonText}
      />
      <FailurePopup
        show={showFailurePopup}
        description={alertMessage}
        showOkayButton={showOkayButton}
        showCancelButton={showCancelButton}
        onOkay={onCloseFailurePopup}
        cancelText={cancelButtonText}
        onCancel={cancelButtonAction}
        displayText={titleOfPopup}
      />
      <div className="OnBoarding-Container">
        <div className="inputDivStyle-onboarding">
          <div className="textDiv__login">
            <div className="onboarding-illustration">
              <OnBoarding />
            </div>
            <p className="text__create_Illustration">{t.PROCESS_COMPLETE}</p>
          </div>

          <div className="btn-class">
            <ButtonMain
              title={!loading ? 'Save Onboarding Information' : 'Saving ....'}
              className={!loading ? 'buttonStyleEnable' : 'buttonStyleDisabled'}
              onClick={handlerChange}
              disabled={loading}
            />
            <ButtonMain
              title={t.BTN_BACK}
              className="btn__back"
              onClick={() => setSelectOnBoarding(2)}
              disabled={loading}
            />
          </div>
        </div>
      </div>
      <FooterTrustChat />
    </div>
  );
}
ProcessComplete.defaultProps = {
  boardingPhone: '',
  boardingName: '',
  boardingTimezone: 'UTC',
  boardingLanguage: 'en',
  customerCompanyWebsite: '',
  customerAssignRole: '',
  leadContainer: '',
  leadJobTilte: '',
  emailBoarding: '',
  logoUpload: null,
};

ProcessComplete.propTypes = {
  boardingPhone: PropTypes.string,
  boardingName: PropTypes.string,
  boardingTimezone: PropTypes.string,
  boardingLanguage: PropTypes.string,
  customerCompanyWebsite: PropTypes.string,
  customerAssignRole: PropTypes.string,
  leadContainer: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  leadJobTilte: PropTypes.string,
  emailBoarding: PropTypes.string,
  logoUpload: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  setSelectOnBoarding: PropTypes.func.isRequired,
};

export default ProcessComplete;
